<app-loader *ngIf="loginCarg"></app-loader>
<div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Cambiar contraseña</h5>
      <button class="close" data-dismiss="modal" aria-label="Close" (click)="closeModel()">
        <fa-icon [icon]="faClose"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="loginFormChangePass">
        <!-- <h2>
            Ingresa tu actual y nueva contraseña para completar el proceso.
          </h2>
        
          <p>
            Tu contraseña debe tener las siguientes características:
          </p>
          <ul>
            <li>Debe contener por lo menos 8 caracteres.</li>
            <li>Debe incluir un número y un carácter especial (*#+!%$”?).</li>
            <li>Debe incluir letra mayúscula y minúscula.</li>
          </ul> -->
        <div class="form-group">
            <app-input-text type="password" label="Contraseña Actual" placeholder="Escribe aquí" frmControl="lastpassword"
              class_label="white" [formParent]="loginFormChangePass"></app-input-text>
          </div>
          <div class="form-group">
            <app-input-text type="password" label="Contraseña Nueva" placeholder="Escribe aquí" frmControl="newpassword"
              class_label="white" [formParent]="loginFormChangePass"></app-input-text>
          </div>
          <div class="form-group">
            <app-input-text type="password" label="Confirmar Contraseña" placeholder="Escribe aquí" frmControl="passwordConfirm"
              class_label="white" [formParent]="loginFormChangePass"></app-input-text>
          </div>
        <button type="submit" class="btn btn-primary btn-block" 
          (click)="recover()" [disabled]="!loginFormChangePass.valid  || !loginFormChangePass.value.lastpassword || !loginFormChangePass.value.newpassword || !loginFormChangePass.value.passwordConfirm ">Cambiar contraseña</button>
      </form>
    </div>
  </div>
  